import './index.css'
import React from 'react'
import classnames from 'classnames'

const TabBar = ({ items, onClickItem, selected }) => {
  return (
    <div className="tabBar">
      {items.map((item, index) => (
        <div className={classnames('tabItem', { selected: selected === item })} onClick={() => onClickItem(item)}>
          <span className="tabLink">{item}</span>
        </div>
      ))}
    </div>
  )
}

export default TabBar
